import { HELP_URI } from '../domain/constants/Help-uri'

export const buildHelpUri = (slug: string) => ({
  article: `${HELP_URI}/article/${slug}`,
  category: `${HELP_URI}/category/${slug}`,
})
